export const DEFAULT_MAX_CHARS = 255;

export const DEFAULT_SENDER_EMAIL = 'online@bayad.com';

export const FILE_FORMATS = ['CSV', 'XLS'];
